import { useQuery } from 'react-query'

import { IFilter } from 'src/components/filter/types/filter.types'
import ProductService from 'src/services/product.service'

import { removeDefaultParams } from 'src/common/utils'
import { QUERY_KEYS } from 'src/constants'

const initialProductsAllFilter: IFilter = {
  query: '',
  step: ['all'],
  journey: ['all'],
  account: ['all'],
  ai_generated: ['all'],
}

const useAllProducts = (filter: IFilter) => {
  return useQuery(
    [QUERY_KEYS.PRODUCTS_ALL, filter],
    () => ProductService.getAllProducts(removeDefaultParams(filter, initialProductsAllFilter)),
    {
      keepPreviousData: true,
    },
  )
}

export { useAllProducts, initialProductsAllFilter }
